export default __webpack_public_path__ + "static/media/notifications.d8ef53ea.svg";